import { render, staticRenderFns } from "./reset-password-new-password-form.vue?vue&type=template&id=4d0024d0&"
import script from "./reset-password-new-password-form.vue?vue&type=script&lang=js&"
export * from "./reset-password-new-password-form.vue?vue&type=script&lang=js&"
import style0 from "./reset-password-new-password-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports